<template>
  <v-container class="mt-5">
    <StatisticFilters :user="user" />
    <StatisticTable :user="user" />
  </v-container>
</template>

<script>
import StatisticTable from "@/components/table/StatisticTable";
import StatisticFilters from "@/components/filters/StatisticFilters";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Statistic",
  components: { StatisticFilters, StatisticTable },
  methods: {
    ...mapActions({
      loadAgents: "agents/loadAgents",
      loadSources: "sources/loadSources",
      loadStatistic: "statistic/loadStatistic",
    })
  },
  mounted() {
    if(this.user.role_id == 1){
      this.loadAgents();
    }
    this.loadSources();
    this.loadStatistic();
  },
  computed: {
    ...mapGetters({
      user: "auth/user"
    }),
  },
};
</script>
